import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Constrants from "../constrants/constrant";
import { useToast } from "../context/ToastProvider";
import { Link } from "react-router-dom";
import { useSettings } from "../context/SettingsProvider";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

function Login() {
  const { login } = useContext(AuthContext);
  const { settings } = useSettings();
  const navigate = useNavigate();
  const { addToast } = useToast();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const user = localStorage.getItem("user");

    if (token && user) {
      addToast("You are already logged in!", "info", 3000);
      navigate("/");
    }
  }, [navigate, addToast]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {

      const res = await Constrants.post("/web/login", {
        email,
        password,
      });

      if (res.data && res.data.token && res.data.user) {
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("user", JSON.stringify(res.data.user));

        login(res.data.user);

        addToast("You are successfully logged in!", "success", 4000);

        navigate("/");
      } else {
        setError("Login response format is invalid. Please contact support.");
      }
    } catch (err) {

      if (err.response) {
        const { status, data } = err.response;

        if (data && data.message) {
          setError(data.message);
          addToast(data.message, "error");
        } else if (data && data.errors) {
          const errors = Object.values(data.errors).flat();
          const errorMessage = errors.join(", ");
          setError(errorMessage);
          addToast(errorMessage, "error");
        } else if (status === 419) {
          const errorMessage = "CSRF token mismatch. Please refresh the page and try again.";
          setError(errorMessage);
          addToast(errorMessage, "error");
        } else if (status === 401) {
          const errorMessage = "Invalid email or password.";
          setError(errorMessage);
          addToast(errorMessage, "error");
        } else if (status === 422) {
          const errorMessage = "Please check your email and password.";
          setError(errorMessage);
          addToast(errorMessage, "error");
        } else {
          const errorMessage = `Server error (${status}). Please try again.`;
          setError(errorMessage);
          addToast(errorMessage, "error");
        }
      } else if (err.request) {
        console.error("No response received:", err.request);
        const errorMessage = "Cannot connect to server. Please check your internet connection.";
        setError(errorMessage);
        addToast(errorMessage, "error");
      } else {
        console.error("Request setup error:", err.message);
        const errorMessage = "Something went wrong. Please try again.";
        setError(errorMessage);
        addToast(errorMessage, "error");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="main-content">
      <div className="auth-container">
        <div className="auth-card active" id="loginCard">
          <div className="auth-header">
            <div className="auth-logo">
              <div className="logo-icon" style={{ width: "48px", height: "48px" }}>
                <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" fill="white">
                  <path d="M0 0h24v24H0V0z" fill="none" /><path d="M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2-.13-.24-.04-.55.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67-.09.18-.26.28-.44.28zM3.5 9.72c-.1 0-.2-.03-.29-.09-.23-.16-.28-.47-.12-.7.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25.16.22.11.54-.12.7-.23.16-.54.11-.7-.12-.9-1.26-2.04-2.25-3.39-2.94-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07c-.13 0-.26-.05-.35-.15-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39s-4.66 1.97-4.66 4.39c0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1-1.4-1.39-2.17-3.24-2.17-5.22 0-1.62 1.38-2.94 3.08-2.94s3.08 1.32 3.08 2.94c0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29-.49-1.31-.73-2.61-.73-3.96 0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z" />
                </svg>
              </div>
            </div>
            <h1 className="auth-title">Sign in</h1>
            <p className="auth-subtitle">Use your account</p>
          </div>

          <form className="auth-form" id="loginForm" onSubmit={handleLogin}>
            {error && <div className="form-error" style={{ color: "red", marginBottom: "1rem" }}>{error}</div>}

            <div className="form-group">
              <label htmlFor="loginEmail" className="form-label">Email or username</label>
              <input
                type="email"
                id="loginEmail"
                className="form-input"
                placeholder="Enter your email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label htmlFor="loginPassword" className="form-label">Password</label>
              <input
                type="password"
                id="loginPassword"
                className="form-input"
                placeholder="Enter your password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <div className="form-options">
              <label className="checkbox-label">
                <input type="checkbox" className="form-checkbox" />
                <span>Remember me</span>
              </label>
              <Link to="/forgot-password" className="link-text">Forgot password?</Link>
            </div>

            <button type="submit" className="auth-btn primary" disabled={loading}>
              {loading ? "Signing in..." : "Sign in"}
            </button>
          </form>

          <div className="auth-footer">
            Don't have an account? <Link to={'/register'} className="link-text" onclick="showCard('registerCard'); return false;">Create account</Link>
          </div>

        </div>
      </div>
      <section className="section">
        <div className="section-header">
          <h2 className="section-title">Why join {settings?.website_name}?</h2>
        </div>
        <div className="categories-grid">
          <div className="category-card">
            <div
              className="category-icon"
              style={{ border: "1px solid #acacacff", alignContent: "center", justifyContent: "center", display: "flex", alignItems: "center" }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="white"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z" /></svg>              </div>
            <div className="category-name">Access millions of apps</div>
          </div>

          <div className="category-card">
            <div
              className="category-icon"
              style={{ background: "linear-gradient(45deg, #ff9800, #ff5722)", border: "1px solid #acacacff", alignContent: "center", justifyContent: "center", display: "flex", alignItems: "center" }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#e3e3e3"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z" /></svg>
            </div>
            <div className="category-name">Sync across devices</div>
          </div>

          <div className="category-card">
            <div
              className="category-icon"
              style={{ background: "linear-gradient(45deg, #9c27b0, #e91e63)", border: "1px solid #acacacff", alignContent: "center", justifyContent: "center", display: "flex", alignItems: "center" }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#e3e3e3"><g><path d="M0,0h24v24H0V0z" fill="none" /></g><g><path d="M12,2L4,5v6.09c0,5.05,3.41,9.76,8,10.91c4.59-1.15,8-5.86,8-10.91V5L12,2z M18,11.09c0,4-2.55,7.7-6,8.83 c-3.45-1.13-6-4.82-6-8.83V6.31l6-2.12l6,2.12V11.09z M8.82,10.59L7.4,12l3.54,3.54l5.66-5.66l-1.41-1.41l-4.24,4.24L8.82,10.59z" /></g></svg>
            </div>
            <div className="category-name">Secure &amp; private</div>
          </div>

          <div className="category-card">
            <div
              className="category-icon"
              style={{ background: "linear-gradient(45deg, #2196f3, #00bcd4)", border: "1px solid #acacacff", alignContent: "center", justifyContent: "center", display: "flex", alignItems: "center" }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#e3e3e3"><g><rect fill="none" height="24" width="24" /><path d="M16,4c0-1.11,0.89-2,2-2s2,0.89,2,2s-0.89,2-2,2S16,5.11,16,4z M20,22v-6h2.5l-2.54-7.63C19.68,7.55,18.92,7,18.06,7h-0.12 c-0.86,0-1.63,0.55-1.9,1.37l-0.86,2.58C16.26,11.55,17,12.68,17,14v8H20z M12.5,11.5c0.83,0,1.5-0.67,1.5-1.5s-0.67-1.5-1.5-1.5 S11,9.17,11,10S11.67,11.5,12.5,11.5z M5.5,6c1.11,0,2-0.89,2-2s-0.89-2-2-2s-2,0.89-2,2S4.39,6,5.5,6z M7.5,22v-7H9V9 c0-1.1-0.9-2-2-2H4C2.9,7,2,7.9,2,9v6h1.5v7H7.5z M14,22v-4h1v-4c0-0.82-0.68-1.5-1.5-1.5h-2c-0.82,0-1.5,0.68-1.5,1.5v4h1v4H14z" /></g></svg>
            </div>
            <div className="category-name">Family sharing</div>
          </div>

          <div className="category-card">
            <div
              className="category-icon"
              style={{ background: "linear-gradient(45deg, #4caf50, #8bc34a)", border: "1px solid #acacacff", alignContent: "center", justifyContent: "center", display: "flex", alignItems: "center" }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#e3e3e3"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z" /></svg>
            </div>
            <div className="category-name">Exclusive rewards</div>
          </div>

          <div className="category-card">
            <div
              className="category-icon"
              style={{ background: "linear-gradient(45deg, #607d8b, #455a64)", border: "1px solid #acacacff", alignContent: "center", justifyContent: "center", display: "flex", alignItems: "center" }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#e3e3e3"><g><rect fill="none" height="24" width="24" /></g><g><path d="M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M19.46,9.12l-2.78,1.15 c-0.51-1.36-1.58-2.44-2.95-2.94l1.15-2.78C16.98,5.35,18.65,7.02,19.46,9.12z M12,15c-1.66,0-3-1.34-3-3s1.34-3,3-3s3,1.34,3,3 S13.66,15,12,15z M9.13,4.54l1.17,2.78c-1.38,0.5-2.47,1.59-2.98,2.97L4.54,9.13C5.35,7.02,7.02,5.35,9.13,4.54z M4.54,14.87 l2.78-1.15c0.51,1.38,1.59,2.46,2.97,2.96l-1.17,2.78C7.02,18.65,5.35,16.98,4.54,14.87z M14.88,19.46l-1.15-2.78 c1.37-0.51,2.45-1.59,2.95-2.97l2.78,1.17C18.65,16.98,16.98,18.65,14.88,19.46z" /></g></svg>
            </div>
            <div className="category-name">24/7 support</div>
          </div>
        </div>

      </section>
    </main>
  );
}

export default Login;